/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ delta: NonNullable<unknown>, period: NonNullable<unknown> }} Coinvestments_Report_Vsperiod2Inputs */

const en_coinvestments_report_vsperiod2 = /** @type {(inputs: Coinvestments_Report_Vsperiod2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} vs ${i?.period}`)
};

/**
* | output |
* | --- |
* | "{delta} vs {period}" |
*
* @param {Coinvestments_Report_Vsperiod2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_vsperiod2 = /** @type {((inputs: Coinvestments_Report_Vsperiod2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Vsperiod2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_vsperiod2(inputs)
});
export { coinvestments_report_vsperiod2 as "coInvestments_report_vsPeriod" }